import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    border: 'none',
    position: 'relative',
    minWidth: 325,
    transition: 'transform ease-in-out 200ms',
    boxShadow: '0 8px 40px 0 rgba(0, 0, 0, 0.10)',

    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  contestSection: {
    width: '100%',
  },
  contestInfo: {
    flex: 1,
    minWidth: 0,
  },
  brandAvatar: {
    width: 48,
    height: 48,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&.brandRyp': {
      backgroundColor: '#050606',
    },
    '&.brandOfp': {
      backgroundColor: '#163E67',
    },
    '&.brandSplash': {
      backgroundColor: theme.black,
    },
  },
  contestName: {
    color: theme.colors.gray[9],
    fontWeight: 800,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  metaDivider: {
    color: theme.colors.gray[6],
  },
  contestMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
  },
}));

export default useStyles;
